(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('VoceBilancioDetailController', VoceBilancioDetailController);

    VoceBilancioDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'VoceBilancio', 'Decisione'];

    function VoceBilancioDetailController($scope, $rootScope, $stateParams, previousState, entity, VoceBilancio, Decisione) {
        var vm = this;

        vm.voceBilancio = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:voceBilancioUpdate', function(event, result) {
            vm.voceBilancio = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
